import { Module } from 'vuex';

import { LoggedOutCoupon, RootState } from 'frontend/types';

const recentCourses: Module<LoggedOutCoupon, RootState> = {
  namespaced: true,
  state: () => ({
    expiration_time: undefined,
    code: undefined,
    coupon_generated: undefined,
    percent_off: undefined,
    rough_num_courses: undefined,
  }),
  getters: {
    activeLoggedOutCoupon(state: LoggedOutCoupon): LoggedOutCoupon | null {
      if (state.expiration_time && state.expiration_time > Date.now()) {
        return state;
      }
      return null;
    },
    expirationDate(state: LoggedOutCoupon, getters: any): string {
      const coupon = getters.activeLoggedOutCoupon;
      if (coupon) {
        const d = new Date(coupon.expiration_time);
        const monthNum = d.getMonth() + 1;
        const dayNum = d.getDate();
        return `${monthNum}/${dayNum}`;
      }
      return '';
    },
  },
  mutations: {
    setValue(state: LoggedOutCoupon, value: LoggedOutCoupon): void {
      const expirationOverride = {
        // Convert expiration time to ms
        expiration_time: value.expiration_time ? value.expiration_time * 1000 : undefined,
      };
      Object.assign(state, value, expirationOverride);
    },
  },
};

export default recentCourses;
